<template>
	<div class="like horizontal-center">
		<img :src="fixLikedIcon(isLiked)" :class="{ 'is-click': isClick }" @click="onClick" style="width: 30px; height: 26px"/>
		<span class="count">{{ count }}</span>
		<div class="text">いいね！</div>
	</div>
</template>

<script>

export default {
	name: 'Like',
	props: {
		count: {
			type: Number,
			default: 0,
		},
		isLiked: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			isClick: false,
		}
	},
	mounted() {
	},
	computed: {
	},
	methods: {
		onClick: function() {
			this.isClick = true;
			setTimeout(function() {
				this.isClick = false;
			}.bind(this), 500);

			this.$emit('click');
		},
		fixLikedIcon: function(isLiked) {
			if (isLiked) {
				return require('@/assets/icons/like.svg');
			} else {
				return require('@/assets/icons/unlike.svg');
			}
		},
	},
}
</script>

<style lang="scss">

</style>
